import { Congress, CongressesService, CreateCongressData } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useCreateCongress(
  mutationOptions?: UseMutationOptions<Congress, HttpError, CreateCongressData>,
) {
  return useMutation({
    mutationFn: CongressesService.createCongress,
    ...mutationOptions,
  });
}

export { useCreateCongress };
